'use client';

import React from 'react';
import CosaServiceLayout from '@/components/CosaServiceLayout';

const serviceData = {
  slug: 'evacuation-sanitaire',
  icon: 'fa-solid fa-truck-medical',
  badge: 'Évacuation Sanitaire',
  title: 'Évacuation Sanitaire',
  subtitle: 'Transport médical sécurisé vers les centres spécialisés',
  heroImage: '/assets/images/service_medical_evacuation.png',
  heroAlt: 'Ambulance médicale africaine COSA pour évacuation sanitaire d\'urgence',
  accentColor: '#0e5932',
  description: `Le service d'évacuation sanitaire de COSA, en partenariat avec les autorités locales, accompagne les patients vers les centres spécialisés appropriés. Nous assurons un transport sécurisé et professionnel avec équipe médicale qualifiée.`,
  features: [
    { icon: 'fa-solid fa-ambulance', title: 'Transport Médical', description: 'Ambulances équipées et personnel médical qualifié pour transport sécurisé.' },
    { icon: 'fa-solid fa-phone', title: 'Disponibilité 24/7', description: 'Service d\'evacuation disponible 24 heures sur 24, 7 jours sur 7.' },
    { icon: 'fa-solid fa-route', title: 'Coordination Réseau', description: 'Coordination avec les centres spécialisés et autorités locales.' },
    { icon: 'fa-solid fa-user-nurse', title: 'Équipe Médicale', description: 'Personnel médical et paramédical formé aux protocoles d\'evacuation.' },
    { icon: 'fa-solid fa-gps', title: 'Suivi en Temps Réel', description: 'Suivi GPS en temps réel de l\'ambulance et communication constante.' },
    { icon: 'fa-solid fa-file-contract', title: 'Partenariats Officiels', description: 'Partenariats avec les autorités sanitaires et centres de référence.' },
  ],
  process: [
    { step: '01', title: 'Appel d\'Urgence', description: 'Contactez-nous immédiatement en cas d\'urgence médicale.' },
    { step: '02', title: 'Évaluation Médicale', description: 'Notre équipe évalue la situation et détermine le centre approprié.' },
    { step: '03', title: 'Déploiement Ambulance', description: 'Ambulance déployée immédiatement avec équipe médicale.' },
    { step: '04', title: 'Transport Sécurisé', description: 'Transport vers le centre spécialisé avec suivi médical continu.' },
  ],
  stats: [
    { value: '100+', label: 'évacuations annuelles' },
    { value: '15min', label: 'temps de réponse moyen' },
    { value: '24/7', label: 'disponibilité' },
    { value: '100%', label: 'taux de satisfaction' },
  ],
};

export default function EvacuationSanitairePage() {
  return <CosaServiceLayout service={serviceData} />;
}
